import { customAxios, IDUSUARIO, STOCK_URL } from '../constants';
import { FETCH_FAMILIAS,FETCH_FAMILIAS_SKU, FETCH_FAMILIAS_X_AREAVTA } from './types';
import { evalAction, serverError } from '../utils/actionError';

export function fetchFamilia() {
  const request = customAxios.post(`${STOCK_URL}/maestros/familiaVeh/accesoUsuarioListar`, {});

  return {
    type: FETCH_FAMILIAS,
    payload: request,
  };
}

export function fetchFamiliaPorAreaVta(areaVta) {
  const config = {
    params: {
      codAreaVta: areaVta.length < 1 ? '' : `[${areaVta}]`,
    },
    headers: {
      idUsuario: IDUSUARIO,
    },
  };
  const request = customAxios.get(`${STOCK_URL}/maestros/familia-vehiculo`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_FAMILIAS_X_AREAVTA,
    payload: request,
  };
}


export function fetchFamiliaxUser(codFamilia,) {
  const config = {
    headers: {
      indPaginado: 'S',//Al parecer no usa este parámetro pero en el SOAPUI si se lo enviaba
      nroPag:1,
      cantidadxPag: '10',
    },
  };
  const params = {  
    codFamilia: codFamilia,  
  };
  const request = customAxios.post(`${STOCK_URL}/skuvehiculo/skuVeh/listarFamilia`,params, config)
    .then(({ data }) => evalAction(data, 'listaFamilia'))
    .catch(error => serverError(error, 'listaFamilia'));
  return {
    type: FETCH_FAMILIAS_SKU,
    payload: request,};
}


// WEBPACK FOOTER //
// ./src/actions/Familias.js